import React from 'react';
import "./footer_styles.css";


const Footer = () => {
    return (
        <>
            <footer className="footer__bg">
                <p className="design__copyright">
                    Designed by <a href="https://www.behance.net/martinmadami" rel="noreferrer" target="_blank" className="design__link">the UX Guy</a>
                </p>
            </footer>
        </>
    )
}

export default Footer;